export const loadCart = () => {
  try {
    const raw = localStorage.getItem("cart") || "[]";
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const saveCart = (cart) => {
  localStorage.setItem("cart", JSON.stringify(cart));
  window.dispatchEvent(new Event("cartUpdated"));
};

export const cartCount = (cart) =>
  cart.reduce((sum, item) => sum + (item.quantity || 0), 0);

export const cartTotal = (cart) =>
  cart.reduce((sum, item) => sum + item.quantity * item.price, 0);